"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importStar(require("react"));
var qrcode_react_1 = __importDefault(require("qrcode.react"));
var loader_1 = __importDefault(require("../loader"));
var config = {
    fgColor: '#000000',
    bgColor: '#ffffff',
    level: 'M',
    renderAs: 'svg',
    includeMargin: false
};
var Qr = function (_a) {
    var promise = _a.promise, size = _a.size, value = _a.value;
    var _b = react_1.useState(value || null), innerValue = _b[0], setInnerValue = _b[1];
    react_1.useEffect(function () {
        setInnerValue(value || null);
    }, [value]);
    if (!promise && !value) {
        console.error('QRCode: Please provide a value or a promise.');
        return null;
    }
    if (promise) {
        promise.then(function (result) { return setInnerValue(result); });
    }
    if (!innerValue) {
        return react_1["default"].createElement(loader_1["default"], null);
    }
    return (react_1["default"].createElement(qrcode_react_1["default"], { value: innerValue, size: size, fgColor: config.fgColor, bgColor: config.bgColor, level: config.level, renderAs: config.renderAs, includeMargin: config.includeMargin, "data-testid": "qrcode" }));
};
exports["default"] = Qr;
